import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  FlatList,
  Pressable,
  StyleSheet,
  Text,
  View,
} from "react-native";
import {
  color_333333,
  color_666666,
  color_999999,
  color_main,
  ColorLine,
  primary50,
  white,
} from "../../assets/style/colors";
import * as ImSdk from "../../../imsdk/api";
import { LeftView } from "./CListItem";
import { ChartMessageItem, MessageType } from "../../constants/types";
import { beforeDatePlus, isGroupTopic } from "../../utils/utils";
import { ListEmpty } from "../../components/ListEmpty";
import { MainNavProps } from "../navigation/main/MainParamList";
import { fix_msgs_user } from "../../store/ChatStore";
import { getUserName } from "./chat-helper";
import {
  Str_Cancel,
  Str_Date,
  Str_File,
  Str_GroupMembers,
  Str_Img,
  Str_QuickSearchMsgContent,
  Str_Search,
  Str_Video,
  Str_Voice,
} from "../../language/string_res";
import { Div } from "./ChatSearch";
import { useIsFocused } from "@react-navigation/native";
import { CSearchInput } from "../../components/CSearchInput";
import { ButtonView } from "../../components/ButtonView";
import { TextContentRender } from "./components/TextRender";
import { ScreenCloseModal } from "../../components/ScreenModal";
import { DocumentRender } from "./components/DocumentRender";
let searchTimer: any = null;
let page = 0;
let hasMore = true;

export function SearchChatResultScreen({
  navigation,
  route,
}: MainNavProps<"SearchChatResultScreen">) {
  const { tid, curSearch, isAdmin } = route.params;
  const [search, setSearch] = useState<string>(curSearch ?? "");
  const [message, setMessage] = useState<ChartMessageItem[]>();
  const [isLoading, setIsLoading] = useState(false);
  const im = ImSdk.getInstance();
  const isFocused = useIsFocused();

  useEffect(() => {
    page = 0;
    hasMore = true;
  }, []);
  useEffect(() => {
    if (isFocused && curSearch && curSearch.length > 0) {
      doSearch(curSearch);
    }
  }, [isFocused, curSearch]);

  const doSearch = (text: string, isLoad: boolean = false) => {
    if (text) {
      setIsLoading(true);
      im.SearchMsg({
        tid: tid,
        page: page,
        mask: 0,
        type: [MessageType.TEXT,MessageType.DOCUMENT],
        searchVal: text,
      })
        .then((res) => {
          hasMore = res.msgs?.length === 50;
          if (res.msgs) {
            const msgs = res.msgs as ChartMessageItem[];
            const fmsgs = msgs.filter(
              (value) => value.type !== MessageType.SYSTEM
            );
            fix_msgs_user(tid, fmsgs).then(() => {
              if (isLoad) {
                const m = message ?? [];
                m.push(...fmsgs);
                setMessage(m);
              } else {
                setMessage(fmsgs);
              }
            });
          } else {
            setMessage([]);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  function loadmore() {
    if (message && message.length > 0 && hasMore && search) {
      ++page;
      doSearch(search, true);
    }
  }

  const onChangeText = (text: string) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
    }
    setSearch(text);
    searchTimer = setTimeout(() => {
      page = 0;
      doSearch(text);
    }, 500);
  };

  const renderItem = ({ item }: { item: ChartMessageItem }) => {
    return (
      <Pressable
        onPress={() => {
          //TODO: 跳转
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "flex-start",
            paddingStart: 12,
            paddingVertical: 16,
          }}
        >
          <LeftView left={{ avatar: item.user?.avatar, name: getUserName(item.user), uid: item.user?.uid || 0 }} size={46} isRounded={true} isGroup={false} radius={23} style={{ marginRight: 0 }} />
          <View style={{ flex: 1, justifyContent: "center", marginRight: 12 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={{ color: color_666666, fontSize: 14, textAlign: "left" }}
              >
                {getUserName(item.user)}
              </Text>
              <Text
                style={{
                  color: color_666666,
                  fontSize: 12,
                  textAlign: "right",
                }}
              >
                {beforeDatePlus(item.stime)}
              </Text>
            </View>
           <View style={{ justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'row', marginTop: 6, marginLeft: 2 }}>
							{item.type === MessageType.TEXT && <TextContentRender disabled={true} isSelf={false} item={item} pdLeft={10} />}
							{item.type === MessageType.DOCUMENT && <View>
								<DocumentRender disabled={true} isSelf={false} item={item} pdLeft={0} isTalk={true} />
							</View>}
						</View>
          </View>
        </View>
      </Pressable>
    );
  }; 
  // 渲染底部加载提示
  const ListFooterComponent = () => (
    <View style={{ padding: 20, alignItems: "center" }}>
      {isLoading && <ActivityIndicator size="large" color="#0000ff" />}
    </View>
  );
  const NativeQuickScreen = (type: MessageType) => {
    navigation.navigate("QuickSearchMsgScreen", { tid: tid, type: type });
  };

  const GroupQuick = () => {
    return (
      <View style={{ width: "100%" }}>
        <View style={{ flexDirection: "row" }}>
          <ButtonView
            onPress={() => {
              navigation.navigate("GroupUserList", {
                isSearch: true,
                tid: tid,
                isAdmin: isAdmin,
              });
            }}
            style={styles.quickContainer}
            textStyle={styles.quickText}
            text={Str_GroupMembers}
          />
          <View style={styles.quickLine} />
          <ButtonView
            onPress={() => {
              navigation.navigate("SearchDatePickScreen", { tid });
            }}
            style={styles.quickContainer}
            textStyle={styles.quickText}
            text={Str_Date}
          />
          <View style={styles.quickLine} />
          <ButtonView
            onPress={() => NativeQuickScreen(MessageType.IMAGE)}
            style={styles.quickContainer}
            textStyle={styles.quickText}
            text={Str_Img}
          />
        </View>
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <ButtonView
            onPress={() => NativeQuickScreen(MessageType.VIDEO)}
            style={styles.quickContainer}
            textStyle={styles.quickText}
            text={Str_Video}
          />
          <View style={styles.quickLine} />
          <ButtonView
            onPress={() => NativeQuickScreen(MessageType.VOICE)}
            style={styles.quickContainer}
            textStyle={styles.quickText}
            text={Str_Voice}
          />
          <View style={styles.quickLine} />
          <ButtonView
            onPress={() => NativeQuickScreen(MessageType.DOCUMENT)}
            style={styles.quickContainer}
            textStyle={styles.quickText}
            text={Str_File}
          />
          <ButtonView style={styles.quickContainer} text={""} />
        </View>
      </View>
    );
  };
  const SingleQuick = () => {
    return (
      <View style={{ flexDirection: "row" }}>
        <ButtonView
          style={styles.quickContainer}
          onPress={() => {
            navigation.navigate("SearchDatePickScreen", { tid });
          }}
          textStyle={styles.quickText}
          text={Str_Date}
        />
        <View style={styles.quickLine} />
        <ButtonView
          onPress={() => NativeQuickScreen(MessageType.IMAGE)}
          style={styles.quickContainer}
          textStyle={styles.quickText}
          text={Str_Img}
        />
        <View style={styles.quickLine} />
        <ButtonView
          onPress={() => NativeQuickScreen(MessageType.VIDEO)}
          style={styles.quickContainer}
          textStyle={styles.quickText}
          text={Str_Video}
        />
        <View style={styles.quickLine} />
        <ButtonView
          onPress={() => NativeQuickScreen(MessageType.VOICE)}
          style={styles.quickContainer}
          textStyle={styles.quickText}
          text={Str_Voice}
        />
        <View style={styles.quickLine} />
        <ButtonView
          onPress={() => NativeQuickScreen(MessageType.DOCUMENT)}
          style={styles.quickContainer}
          textStyle={styles.quickText}
          text={Str_File}
        />
      </View>
    );
  };

  return (
    <ScreenCloseModal>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          marginTop: 10,
        }}
      >
        <CSearchInput
          placeholder={Str_Search}
          searchVal={search}
          style={{ flex: 1, borderBottomWidth: 0 }}
          searchContainerStyle={{
            marginHorizontal: 0,
            marginLeft: 12,
            borderRadius: 0,
            borderTopLeftRadius: 5,
            borderBottomLeftRadius: 5,
            backgroundColor: primary50,
          }} // 覆盖原来的
          onClean={() => {
            setSearch("");
            setMessage([]);
          }}
          onChange={onChangeText}
        />

        <Pressable
          style={styles.searchCancleBox}
          onPress={() => navigation.goBack()}
        >
          <Text style={styles.searchCancle}>{Str_Cancel}</Text>
        </Pressable>
      </View>
      {(!message || message.length === 0) && (
        <View style={{ alignItems: "center", paddingHorizontal: 20 }}>
          <Text
            style={{
              color: color_999999,
              fontSize: 16,
              marginVertical: 20,
            }}
          >
            {Str_QuickSearchMsgContent}
          </Text>
          {isGroupTopic(tid) ? <GroupQuick /> : <SingleQuick />}
        </View>
      )}
      <FlatList
        data={message}
        keyExtractor={(item) => item.mid}
        ListEmptyComponent={
          !isLoading && search && search?.length > 0 ? <ListEmpty /> : null
        }
        ItemSeparatorComponent={Div}
        onEndReached={loadmore}
        onEndReachedThreshold={0.1}
        keyboardDismissMode="on-drag"
        ListFooterComponent={ListFooterComponent}
        renderItem={renderItem}
      />
    </ScreenCloseModal>
  );
}

const styles = StyleSheet.create({
  search: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 18,
    marginStart: 12,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    backgroundColor: primary50,
  },
  searchText: {
    fontSize: 15,
    color: color_333333,
    marginStart: 9,
    paddingVertical: 8,
    flex: 1,
  },
  quickContainer: {
    paddingVertical: 8,
    alignItems: "center",
    marginHorizontal: 20,
    justifyContent: "center",
    flex: 1,
  },
  quickText: {
    fontSize: 18,
    color: color_main,
  },
  quickLine: {
    width: 0.5,
    marginVertical: 4,
    backgroundColor: ColorLine,
  },
  searchCancleBox: {
    fontSize: 14,
    height: 40,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color_main,
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginRight: 12,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    overflow: "hidden",
  },
  searchCancle: {
    color: white,
    fontSize: 14,
  },
});
